<div class="loader-overlay">
  <div class="spinner"></div>
  <p>{{ message }}</p>
</div>
